import { format, isWithinInterval } from 'date-fns';

import { TggMembershipType } from '@tgg/common-types';

import { PromoCode } from '../../Membership/Membership.types';

export const getPromoCode = (
    allPromoCodes: PromoCode[],
    membershipType: TggMembershipType,
): PromoCode | undefined => {
    return allPromoCodes.find(
        promoCode =>
            membershipType === promoCode.membershipType &&
            isWithinInterval(
                new Date(format(new Date().setHours(0), 'yyyy-MM-dd')),
                {
                    start: new Date(promoCode.startDate),
                    end: new Date(promoCode.endDate),
                },
            ),
    );
};
